export const
    computeChartIndex = (isSpouse) => {
        return isSpouse ? 1 : 0;
    },
    computeChartStringKey = (owner, section, fpId, clientId) => {
        return `ILPC_${owner}_${section.replace(/\s/g, "")}_${fpId}_${clientId}`;
    };